import React, { useEffect, useState, useContext, Fragment } from 'react';
import {getFridayDates,shortMonthToMonthNumber,isMonthAndYearEmpty,isNumeric,getButtonDisabledStates,getStatusFlagValue} from '../Custom/Custom'
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import messages from '../assets/Messages.json'
import axios from "axios";
import { API_URL } from '../Constant';
import {showLoading } from 'react-global-loading';
import priceTitle from '../price.json';


function WholeSalePriceData({
	wholeSalePrice,
	yearName,
	monthName,
	districtCode,
	userInfoObject,
	payload,
	config,
	resetMothAndYearField,
	url}) {
	const storedLanguage = localStorage.getItem('language');
	const [itemData, setItemData] = useState({});
	let fridayDates = '';
	let districtAndDivision=false;
	let isDisable=false;
	let monthInDigit=shortMonthToMonthNumber(monthName)
	let headQuarterRemark=['Price is Too Low',
	'Price is too High',
	'Price does not match with unit' ,
	'Price does not match with variety',
	'Other.'
]
let otherRemark=[
	'Production is low',
	'Production is high',
	'Less supply',
	'Not Available.',
	'On sale.',
	'Seasonal effect',
	'Discounted Item',
	'Other.'

]
	const css = {
		borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) black',
		borderStyle: 'solid',
		borderWidth: '1px 1px 1px 3px'
	};
	
	if (yearName) {
		fridayDates = getFridayDates(yearName, monthInDigit);
	}
	const navigate = useNavigate();
	const {
		isSaveBtnDisable,
		isSubmitBtnDisable,
		isAcceptBtnDisable,
		isRejectBtnDisable
	} = getButtonDisabledStates(payload, userInfoObject);


 




const renderHeader = (i) => (
		<thead key={`thead-${i}`}>
		<tr>
		<th rowSpan="2"> {storedLanguage === 'hi' ? priceTitle.hi.Serial_No : priceTitle.en.Serial_No}</th>
                        <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.ITEM_NAME : priceTitle.en.ITEM_NAME}</th>
                        <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.VARITY_NAME : priceTitle.en.VARITY_NAME}</th>
                        <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.UNITE : priceTitle.en.UNITE}</th>
                        <th colSpan="5">{storedLanguage === 'hi' ? priceTitle.hi.MONTHLY_FRIDAY : priceTitle.en.MONTHLY_FRIDAY}</th>
                        <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.AVERAGE : priceTitle.en.AVERAGE}</th>
                        <th rowSpan="2">{storedLanguage === 'hi' ? priceTitle.hi.REMARK : priceTitle.en.REMARK}</th>
                       <th rowSpan="2">REJECT STATUS</th>
		</tr>
		<tr>
		{fridayDates.length > 0 ? (
			<>
				{fridayDates.map((date, index) => (
				<th key={index}>{date}</th>
				))}
				{fridayDates.length === 4 ? <th><th>{storedLanguage === 'hi' ? priceTitle.hi.FIFTH_FRIDAY : priceTitle.en.FIFTH_FRIDAY}</th></th> : ''}
			</>
		) : (
  				<>
		<th>{storedLanguage === 'hi' ? priceTitle.hi.FIRST_FRIDAY : priceTitle.en.FIRST_FRIDAY}</th>
		<th>{storedLanguage === 'hi' ? priceTitle.hi.SECOND_FRIDAY : priceTitle.en.SECOND_FRIDAY}</th>
		<th>{storedLanguage === 'hi' ? priceTitle.hi.THIRD_FRIDAY : priceTitle.en.THIRD_FRIDAY}</th>
		<th>{storedLanguage === 'hi' ? priceTitle.hi.FOURTH_FRIDAY : priceTitle.en.FOURTH_FRIDAY}</th>
		<th>{storedLanguage === 'hi' ? priceTitle.hi.FIFTH_FRIDAY : priceTitle.en.FIFTH_FRIDAY}</th>
        </>
       )}
	
		</tr>
	</thead>
);

useEffect(() => {
    const initialData = {};
   
	   wholeSalePrice.forEach(item => {
          initialData[item.itemCode] = {
            controlled_price: item.controlled_price,
			first_fri_price: item.first_fri_price,
			second_fri_price: item.second_fri_price,
			third_fri_price: item.third_fri_price,
			fourth_fri_price: item.fourth_fri_price,
			fifth_fri_price: (fridayDates.length === 4 && item.fifth_fri_price === 0) ? 0 : 
			(fridayDates.length === 4 ? '' : item.fifth_fri_price),
			averagefirstFri: item.averagefirstFri,
			first_fri_style: css,
			second_fri_style: css,
			third_fri_style: css,
			fourth_fri_style: css,  
			fifth_fri_style: css,
			isRequiredRemark:false,
			isRejectStatus:item.statusFlag === '6',
			remark: item.remark,
			statusFlag:item.statusFlag,
			variety:item.variety,
			unit:item.unit,
			itemVarietyName:item.itemVarietyName,
			itemUnitName:item.itemUnitName,
			first_fri_isRequiredRemark:false,
			second_fri_isRequiredRemark:false,
			third_fri_isRequiredRemark:false,
			fourth_fri_isRequiredRemark:false,
			fifth_fri_isRequiredRemark:false




			// remark_text:item.remark
           
            
          };
        });
     
    setItemData(initialData);
  }, [wholeSalePrice]);


  //console.log(itemData);


const handleItemVariationFirstFriday = (itemCode, field,remarkRequiredField, newValue, average, variation) => {
    if (!(isMonthAndYearEmpty(monthName, yearName))) {
        return;
    }

    let dynamicStylesForTextBox = {};
    let isRequiredRemark = false;

    if (newValue !== 0) {
        let dif = average * variation / 100;
        if (variation === 0 || dif === 0) {
            return;
        }

		

        if (newValue > (parseFloat(average) + dif) || newValue < (average - dif)) {
			
            toast.error(messages.VARIATION_MSG, messages.COLOR_RED);
            dynamicStylesForTextBox = {
                borderColor: 'rgb(220, 223, 225) rgb(220, 223, 225) rgb(220, 223, 225) red',
                borderStyle: 'solid',
                borderWidth: '1px 1px 1px 6px'
            };
            newValue = dynamicStylesForTextBox;
            if(itemData[itemCode].remark ==='NQ' || itemData[itemCode].remark ==='NA' || itemData[itemCode].remark===''){
            isRequiredRemark = true;
            }

        } else {
		
            dynamicStylesForTextBox = {
                borderColor: '#dcdfe1',
                borderStyle: 'solid',
                borderWidth: '1px 1px 1px 6px'
            };
            isRequiredRemark = false;
            newValue = dynamicStylesForTextBox;
        }
    }

    setItemData(prevItemData => ({
        ...prevItemData,
        [itemCode]: {
            ...prevItemData[itemCode],
            [field]: newValue,
            [remarkRequiredField]: isRequiredRemark
        }
    }));
};


const handleFridayOnChange = (itemCode, field, newValue) => {  
     
	if(!(isMonthAndYearEmpty(monthName,yearName))){
	   return;
	}

    //   let isRequiredRemark=false;

	if(!isNumeric(newValue)){
		toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
		newValue='';
	}

	// if(field==='remark' && itemData[itemCode].isRequiredRemark===false && newValue==='' && itemData[itemCode].remark===''){
	// 	isRequiredRemark=true
	// }

		setItemData(prevItemData => {
		const updatedItemData = {
			...prevItemData,
			[itemCode]: {
			...prevItemData[itemCode],
			[field]: newValue,
			// 'isRequiredRemark': isRequiredRemark
			}
		};

		return updatedItemData;
		});
 

};

const handleOnChange=(itemCode, field, newValue)=>{
	if(field==='controlled_price'){
		if(!isNumeric(newValue)){
			toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
			newValue='';
		}

	}
	// let isRequiredRemark=false;
	
	
	// if(field==='remark' && itemData[itemCode].isRequiredRemark===false 
    //     && newValue==='' && itemData[itemCode].remark===''){
    //     isRequiredRemark=true
		
    // }
	setItemData(prevItemData => {
		const updatedItemData = {
			...prevItemData,
			[itemCode]: {
			...prevItemData[itemCode],
			[field]: newValue,
		//    'isRequiredRemark': isRequiredRemark
			}
		};

		return updatedItemData;
		});
}



const handleCheckboxChange=(itemCode,field,newValue)=>{

	    if(!(isMonthAndYearEmpty(monthName,yearName))){
				return;
			}
			let isRequiredRemark=(itemData[itemCode]?.remark && (itemData[itemCode]?.remark !=='NQ' || itemData[itemCode]?.remark !=='NA')? true:false); //required validation for Remarks
			
		  setItemData(prevItemData => ({
			  ...prevItemData,
			  [itemCode]: {
				...prevItemData[itemCode],
				[field]: !prevItemData[itemCode][field] ,
				'isRequiredRemark': isRequiredRemark
			  }
			}));
  
}

const handleUrbanConsumerPriceFormData = async(e, buttonType) => {
   

    const customItemCodes = [];
    let check = 0;
	
	
    let statusFlag = '';
    if (!(isMonthAndYearEmpty(monthName, yearName))) {
        return;
    }
    let clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel); //button click status flag



    for (let itemId in itemData) {
	

		let  requiredTextBoxField=false;
		let count=0;
        // Keep raw strings for logging
        const controlled_price_raw = itemData[itemId].controlled_price ?? '';
        const first_fri_raw = itemData[itemId].first_fri_price ?? '';
        const second_fri_raw = itemData[itemId].second_fri_price ?? '';
        const third_fri_raw = itemData[itemId].third_fri_price ?? '';
        const fourth_fri_raw = itemData[itemId].fourth_fri_price ?? '';
        const fifth_fri_raw = itemData[itemId].fifth_fri_price ?? '';

        // Parse as float to preserve decimals
        let controlled_price = controlled_price_raw !== '' && !isNaN(parseFloat(controlled_price_raw)) ? parseFloat(controlled_price_raw) : 0;
		let first_fri_price = first_fri_raw !== '' && !isNaN(parseFloat(first_fri_raw)) ? parseFloat(first_fri_raw) : 0;
		let second_fri_price = second_fri_raw !== '' && !isNaN(parseFloat(second_fri_raw)) ? parseFloat(second_fri_raw) : 0;
		let third_fri_price = third_fri_raw !== '' && !isNaN(parseFloat(third_fri_raw)) ? parseFloat(third_fri_raw) : 0;
		let fourth_fri_price = fourth_fri_raw !== '' && !isNaN(parseFloat(fourth_fri_raw)) ? parseFloat(fourth_fri_raw) : 0;
		let fifth_fri_price = fifth_fri_raw !== '' && !isNaN(parseFloat(fifth_fri_raw)) ? parseFloat(fifth_fri_raw) : 0;
        let remark = itemData[itemId].remark;
        let isRequiredRemark = itemData[itemId].isRequiredRemark;
        let isRejectStatus = itemData[itemId].isRejectStatus;
		let variety = itemData[itemId].variety;
		let unit = itemData[itemId].unit;
		let itemVarietyName = itemData[itemId].itemVarietyName;
		let itemUnitName = itemData[itemId].itemUnitName;
        statusFlag = (itemData[itemId].statusFlag === '') ? clickButtonStatusFlag : itemData[itemId].statusFlag; //database Statusflag
		let first_fri_isRequiredRemark = itemData[itemId].first_fri_isRequiredRemark;
		let second_fri_isRequiredRemark = itemData[itemId].second_fri_isRequiredRemark;
		let third_fri_isRequiredRemark = itemData[itemId].third_fri_isRequiredRemark;
		let fourth_fri_isRequiredRemark = itemData[itemId].fourth_fri_isRequiredRemark;
		let fifth_fri_isRequiredRemark = itemData[itemId].fifth_fri_isRequiredRemark;
		if(first_fri_isRequiredRemark || second_fri_isRequiredRemark || 
				third_fri_isRequiredRemark || fourth_fri_isRequiredRemark || 
				fifth_fri_isRequiredRemark){
					requiredTextBoxField=true;
				}

    
        if (buttonType === "REJECT" && isRejectStatus) { //Reject Button click condition
            check++;
		
            if ((isRequiredRemark || requiredTextBoxField) && (remark === '' || remark === 'NA' || remark === 'NQ' )) {
                toast.error(messages.REMARK_MSG, messages.COLOR_RED);
                return false;
            }
            statusFlag = clickButtonStatusFlag;
        }

        if (buttonType === "ACCEPT" || buttonType === "SAVE" ) { //Accept Button click
            statusFlag = clickButtonStatusFlag;
            // Remark mandatory if any remark-required flag is true
            if ((isRequiredRemark || requiredTextBoxField) && (remark === '' || remark === 'NA' || remark === 'NQ' )) {
                toast.error(messages.REMARK_MSG, messages.COLOR_RED);
                return false;
            }
        }

		if (buttonType === "SUBMIT") { //Submit Button click
            statusFlag = clickButtonStatusFlag;
        }

        // if (currentPrice === '' || currentPrice === null) {
        // toast.error(messages.CURRENT_PRICE_MSG, messages.COLOR_RED);
        // return false;
        // }
		

        if ((isRequiredRemark || requiredTextBoxField) && remark === '') {
            toast.error(messages.REMARK_MSG, messages.COLOR_RED);
			return false;
        }

        if (remark === '' || remark == null) {
            remark = 'NA';
        }


		// Check and update first Friday price
		if (first_fri_price === null || first_fri_price === "" || first_fri_price === 0) {
			first_fri_price = parseInt(0); 
			count = count + 1;     
		}

		// Check and update second Friday price
		if (second_fri_price === null || second_fri_price === "" || second_fri_price === 0) {
			second_fri_price = parseInt(0); 
			count = count + 1;   
		}

		// Check and update third Friday price
		if (third_fri_price === null || third_fri_price === "" || third_fri_price === 0) {
			third_fri_price = parseInt(0); 
			count = count + 1;  
		}

		// Check and update fourth Friday price
		if (fourth_fri_price === null || fourth_fri_price === "" || fourth_fri_price === 0) {
			fourth_fri_price = parseInt(0);
			count = count + 1;    
		}

		// Check and update fifth Friday price
		if (fifth_fri_price === null || fifth_fri_price === "" || fifth_fri_price === 0) {
			fifth_fri_price = parseInt(0); 
			count = count + 1;
		}



	   	let total =  parseFloat(first_fri_price) + parseFloat(second_fri_price) + parseFloat(third_fri_price) + parseFloat(fourth_fri_price) + parseFloat(fifth_fri_price);


			let average=0;
			if(total !== 0){
			  average = total / (5-count);
			  average = parseFloat(average);
            }

            // Round to 2 decimals for fair comparison
            const roundedAverage = Number(average.toFixed(2));
            const roundedControlled = Number(controlled_price.toFixed(2));

           	if(roundedAverage !== roundedControlled){
			 toast.error(`Entered Average Price is = ${roundedControlled}\nCalculated Average Price = ${roundedAverage}`, messages.COLOR_RED);
             return false;
			}



        const customObject = {
            itemCode: itemId,
            controlled_price: controlled_price,
            first_fri_price: first_fri_price,
            second_fri_price: second_fri_price,
            third_fri_price: third_fri_price,
            fourth_fri_price: fourth_fri_price,
            fifth_fri_price: fifth_fri_price,
            remark: remark,
            status: isRejectStatus,
            statusFlag: statusFlag,
			variety:variety,
			unit:unit,
			itemVarietyName:itemVarietyName,
			itemUnitName:itemUnitName,
        };
        customItemCodes.push(customObject);
    
}
    if (buttonType === "REJECT" && check === 0) {
        toast.error(messages.CHECKBOX_REJECTION_MSG, messages.COLOR_RED);
        return false;
    }

    let postData = {
        itemCodes: customItemCodes,
        payload: {
            month_name: monthInDigit,
            year_name: yearName,
            district_code: districtCode,
            buttonType: buttonType,
			statusButtonFlag:clickButtonStatusFlag
        }
		
    };
	
	showLoading(true)
	try {
	
	 const response = await axios.post(`${API_URL}api${url}`, postData, config);
   if (response.data.status) {
	   toast.success(response.data.message, messages.COLOR_RED);
	 }
   } catch (error) {
	   console.error(error);
	   toast.error('An error occurred while processing your request.', messages.COLOR_RED);
   } finally {
		showLoading(false);
		resetForm();
   }


};

const resetForm=()=>{
   resetMothAndYearField()
  }

const checkBoxcheckedLength=()=>{
   const filteredData = Object.fromEntries(
	  Object.entries(itemData).filter(([key, value]) => value.isRejectStatus === true)
	);
	return Object.keys(filteredData).length
 }




  return (
       <>
         

	{/* <ToastContainer/> */}
       
            <div className="card-body">
       
                <div className="table-responsive">
                    <table className="table table-bordered">
					{renderHeader(0)}

                        <tbody>  
						{ 
						wholeSalePrice && wholeSalePrice.map((item,i)=>{

						
                              
							if(checkBoxcheckedLength() > 0){
								isDisable =true
							}else if( payload.statusFlagSet === "6"){
									if(isAcceptBtnDisable && checkBoxcheckedLength() !==0){
										isDisable =true
									}
								
							} else if(isAcceptBtnDisable){
								 isDisable =true
							}
							
							if( (userInfoObject.userLevel==='DISTRICT LEVEL' ||  userInfoObject.userLevel==='DIVISION LEVEL') ){
								districtAndDivision=true;
							}

							const rowIndex = i + 1;
							return <React.Fragment key={`tableFragment-${i}`}>
							  <tr key={i}>
							<td>{rowIndex}</td>
							<td><input type="text" id={`itemName${i}`} value={item.itemName} disabled className="form-control"/> </td>
							<td><input type="text" id={`itemVarietyName${i}`} value={item.itemVarietyName} disabled className="form-control"/></td>
							<td><input type="text" id={`itemUnitName${i}`} value={item.itemUnitName} disabled className="form-control"/></td>
							<td>
								<input 
								type="text" 
								style={itemData[item.itemCode]?.first_fri_style || {}}
								name={`firstFriday${i}`}
								id={`firstFriday${i}`}
								value={itemData[item.itemCode]?.first_fri_price || 0}   
								className="form-control"
								onChange={e => handleFridayOnChange(item.itemCode, 'first_fri_price', e.target.value)}
								onBlur={e=>handleItemVariationFirstFriday(item.itemCode, 'first_fri_style','first_fri_isRequiredRemark', parseFloat(e.target.value),item.averagefirstFri,item.variationLimit)}
								maxLength={12}
								/>
							</td>
							<td>
								<input 
								type="text" 
								style={itemData[item.itemCode]?.second_fri_style || {}}
								name={`secondFriday${i}`}
								id={`secondFriday${i}`}
								value={itemData[item.itemCode]?.second_fri_price || 0}  
								className="form-control"
								onChange={e => handleFridayOnChange(item.itemCode, 'second_fri_price', e.target.value)}
								onBlur={e=>handleItemVariationFirstFriday(item.itemCode, 'second_fri_style','second_fri_isRequiredRemark', parseFloat(e.target.value),itemData[item.itemCode]?.first_fri_price || '0',item.variationLimit)}
								maxLength={12}
								/>
							</td>
							<td>
								<input 
								type="text" 
								style={itemData[item.itemCode]?.third_fri_style || {}}
								name={`thirdFriday${i}`}
								id={`thirdFriday${i}`}
								value={itemData[item.itemCode]?.third_fri_price || 0}  
								className="form-control"
								onChange={e => handleFridayOnChange(item.itemCode, 'third_fri_price', e.target.value)}
								onBlur={e=>handleItemVariationFirstFriday(item.itemCode, 'third_fri_style','third_fri_isRequiredRemark',parseFloat(e.target.value),itemData[item.itemCode]?.second_fri_price || '0',item.variationLimit)}
								maxLength={12}
								/>
							</td>
							<td>
								<input 
								type="text"
								style={itemData[item.itemCode]?.fourth_fri_style || {}}
								name={`fourthFriday${i}`}
								id={`fourthFriday${i}`} 
								value={itemData[item.itemCode]?.fourth_fri_price || 0}   
								className="form-control"
								onChange={e => handleFridayOnChange(item.itemCode, 'fourth_fri_price', e.target.value)}
								onBlur={e=>handleItemVariationFirstFriday(item.itemCode, 'fourth_fri_style','fourth_fri_isRequiredRemark',parseFloat(e.target.value),itemData[item.itemCode]?.third_fri_price || '0',item.variationLimit)}
								maxLength={12}
                              />
							</td>
							<td>
								<input 
								disabled={(fridayDates.length === 4)? true:false}
								type="text" 
								style={itemData[item.itemCode]?.fifth_fri_style || {}}
								name={`fifthFriday${i}`}
								id={`fifthFriday${i}`} 
								value={itemData[item.itemCode]?.fifth_fri_price || 0}  
								className="form-control"
								onChange={e => handleFridayOnChange(item.itemCode, 'fifth_fri_price', e.target.value)}
								onBlur={e=>handleItemVariationFirstFriday(item.itemCode, 'fifth_fri_style','fifth_fri_isRequiredRemark', parseFloat(e.target.value),itemData[item.itemCode]?.fourth_fri_price || '0',item.variationLimit)}
								maxLength={12}
								/>
							</td>
							<td>
								<input 
								type="text" 
								name={`controlledPrice${i}`}
								id={`controlledPrice${i}`} 
								value={itemData[item.itemCode]?.controlled_price || 0}  
								className="form-control"
								onChange={e => handleOnChange(item.itemCode, 'controlled_price', e.target.value)}
								maxLength={12}
								/>
							</td>
							<td className="grid-row">
							{
							  userInfoObject.userLevel === "HEAD QUARTER" ?
								item.remark !== '' &&  !headQuarterRemark.includes(itemData[item.itemCode]?.remark) &&
								otherRemark.includes(itemData[item.itemCode]?.remark) &&
							    <label className="text-danger" style={{ fontSize: '12px' }}>*{item.remark}</label>
								
								:
								item.remark !== ''  &&  !otherRemark.includes(itemData[item.itemCode]?.remark) &&
								headQuarterRemark.includes(itemData[item.itemCode]?.remark) &&
							    <label className="text-danger" style={{ fontSize: '12px' }}>*{item.remark}</label>
							
					       }
	  
						
								
							<select
							name={`remark${i}`}
							id={`remark${i}`} 
							className="form-select"
							value={itemData[item.itemCode]?.remark || ''}
							onChange={e => handleOnChange(item.itemCode, 'remark' ,e.target.value)}
							>
							<option value="">[---Select---]</option> 
								
                               { userInfoObject.userLevel === "HEAD QUARTER" ?
                          
								headQuarterRemark.map((remarkItem,i)=>{
									return (
									<option value={remarkItem} key={i}>{remarkItem}</option>

								)})
					             :
							
								otherRemark.map((remarkItem,i)=>{
									return (
									<option value={remarkItem} key={i}>{remarkItem}</option>

								)})
							    }

                            </select>
							
						</td>
							
							<td className={itemData[item.itemCode]?.statusFlag === '6' ? 'checkbox_back_color' : ''}>
								<input 
								 disabled={districtAndDivision  ? 'disabled' : ''}
								type="checkbox" 
								name={`status${i}`}
							    id={`status${i}`}
                                onChange={(event)=>handleCheckboxChange(item.itemCode, 'isRejectStatus', event.target.value)}
								checked={itemData[item.itemCode]?.isRejectStatus || false}
								/>
							</td>
					    	 </tr>
							 </React.Fragment>
						})
					} 
                              
                                             
                        </tbody>
                    </table>
                </div>
               
            </div>


			<div className="row">
                    <div className="col-12 text-center pt-3">
					{/* {userInfoObject.userLevel === 'HEAD QUARTER' && ( */}
						<button
							onClick={(e) => handleUrbanConsumerPriceFormData(e, 'SAVE')}
							type="button"
							className={`btn btn_orange mx-1 ${isSaveBtnDisable?'disabled':''}`}
						>
						 Save
						</button>
                      {/* )} */}

                       {(userInfoObject.userLevel==='DISTRICT LEVEL' ||
						// userInfoObject.userLevel==='HEAD QUARTER' ||
						userInfoObject.userLevel==='DIVISION LEVEL') &&
                        <button 
							onClick={(e)=>handleUrbanConsumerPriceFormData(e,'SUBMIT')} 
							type="submit" 
							className={`btn btn_orange mx-1 ${isSubmitBtnDisable?'disabled':''}`}
							>
						    Submit
						 </button>
                       }

                        
                      {(userInfoObject.userLevel==='HEAD QUARTER') && 
                         <>
                         <button 
							onClick={(e)=>handleUrbanConsumerPriceFormData(e,'ACCEPT')} 
							type="button" 
							className={`btn btn_orange mx-1 ${isDisable ? 'disabled' : ''}`} 
							>
						    Accept
						 </button>

                        <button 
							onClick={(e)=>handleUrbanConsumerPriceFormData(e,'REJECT')} 
							type="button" 
							className={`btn btn_orange mx-1 ${isRejectBtnDisable?'disabled':''}`}
						    >
						    Reject
						</button>
                         </>
                      }

                        <button 
					      type="reset" 
						  className="btn btn_orange mx-1"
						  onClick={resetForm} 
						  >
					      Reset
					    </button>

						 <button 
							type="button" 
							className="btn btn_orange mx-1" 
							onClick={(e)=>( navigate("/dashboard"))} 
							>
						Cancel
					   </button>
                    </div>
                    
                </div>


      
      {/* ------------------ */}
       </>
  )
}

export default WholeSalePriceData